import { Fragment, type ComponentType, type ReactNode } from 'react'
import { ChevronIcon } from '../../icons/ChevronIcon'
import { useUiLabels } from '../../labels'

export type BreadcrumbItem = {
  path: string
  label: string
  isLink?: boolean
}

type BreadcrumbLinkProps = {
  to: string
  className?: string
  children: ReactNode
}

export function Breadcrumb({
  items,
  linkAs: LinkComponent,
}: {
  items: BreadcrumbItem[]
  linkAs: ComponentType<BreadcrumbLinkProps>
}) {
  const labels = useUiLabels()
  if (items.length < 2) return null

  return (
    <nav aria-label={labels.breadcrumb} className="ap:flex ap:flex-row ap:items-center ap:gap-xs ap:text-sm">
      {items.map((item, index) => {
        const isLast = index === items.length - 1
        const isLink = item.isLink ?? !isLast

        return (
          <Fragment key={item.path}>
            {index > 0 && (
              <span className="ap:text-content-secondary ap:scale-75">
                <ChevronIcon rotate="right" />
              </span>
            )}
            {isLink ? (
              <LinkComponent
                to={item.path}
                className="ap:text-content-link ap:hover:text-content-link-hover ap:hover:underline"
              >
                {item.label}
              </LinkComponent>
            ) : (
              <span className={isLast ? 'ap:font-semibold ap:text-content-primary' : 'ap:text-content-secondary'}>
                {item.label}
              </span>
            )}
          </Fragment>
        )
      })}
    </nav>
  )
}
